export default __webpack_public_path__ + "static/media/arrowLeft.3ecba922.svg";